module.exports = __webpack_public_path__ + "static/media/pay_checked.034f7082.svg";